import { createApiSlice } from "@common/common-slice/commonSlice";

import { GET_INDUSTRY } from "@routes";

const apiConfig = [
  {
    name: "getIndustry",
    method: "get",
    url: GET_INDUSTRY,
    stateKey: "industryData",
  },
];

const customReducers = {
  initialState: {
    industryData: [],
    selectedData: {},
  },
  reducers: {
  },
};

const { slice, thunks, actions } = createApiSlice(
  "industry",
  apiConfig,
  customReducers
);

const industrySlice = slice;

export default industrySlice.reducer;

export const actionsExports = actions;

export const {
  getIndustry,
} = thunks;